module.exports = new __parcel__URL__("wind_prevision.4d15525c.svg").toString();